import { render, staticRenderFns } from "./TheJsonViewer.vue?vue&type=template&id=79cfbf7c&scoped=true"
import script from "./TheJsonViewer.vue?vue&type=script&lang=js"
export * from "./TheJsonViewer.vue?vue&type=script&lang=js"
import style0 from "./TheJsonViewer.vue?vue&type=style&index=0&id=79cfbf7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cfbf7c",
  null
  
)

export default component.exports